import { Chip, type ChipProps } from "@mui/material";

import { tokens, type StatusTone } from "../theme/theme";

/** Map any backend status string to a tone. Spokes can pass an explicit tone map for their statuses. */
const DEFAULT_TONES: Record<string, StatusTone> = {
  draft: "draft", new: "draft", open: "draft",
  pending: "pending", submitted: "pending", in_review: "pending", awaiting_approval: "pending", past_due: "pending",
  active: "active", approved: "active", confirmed: "active", released: "active", in_progress: "active", trial: "active",
  hold: "hold", on_hold: "hold", rejected: "hold", blocked: "hold", failed: "hold", suspended: "hold",
  done: "done", completed: "done", closed: "done", shipped: "done", posted: "done", delivered: "done",
  cancelled: "cancelled", canceled: "cancelled", archived: "cancelled", void: "cancelled",
};

export function StatusChip({ status, tones, label, ...rest }: {
  status: string;
  tones?: Record<string, StatusTone>;
  label?: string;
} & Omit<ChipProps, "label" | "color">) {
  const tone = tones?.[status] ?? DEFAULT_TONES[status] ?? "draft";
  const color = tokens.status[tone];
  return (
    <Chip
      size="small"
      label={label ?? status.replace(/_/g, " ")}
      sx={{ bgcolor: `${color}1A`, color, fontWeight: 600, textTransform: "capitalize", borderRadius: 1 }}
      {...rest}
    />
  );
}
